import classNames from 'classnames';
import * as React from 'react';

import css from './PurchaseOutlineLabel.module.scss';

interface Props {
  className?: string;
  label: string;
}

const PurchaseOutlineLabel = ({ className, label }: Props) => {
  const classes = classNames(css.PurchaseOutlineLabel, className);

  return <span className={classes}>{label}</span>;
};

export default PurchaseOutlineLabel;
